import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CustomerService } from '../services/customer.service';
import { ErrorService } from '../../../core/services/error.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FooterService } from '../../../core/services/footer.service';
import { CustomerDto } from '../dtos/customer.dto';
import { CustomerFormFactory } from '../mappers/customer-form.factory';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { EmailSenderDto } from '../dtos/email-sender.dto';

@Component({
  selector: 'app-customer',
  imports: [ReactiveFormsModule, MatButtonModule, MatIconModule, MatCardModule, MatFormFieldModule, MatInputModule, MatSelectModule, TranslocoPipe],
  templateUrl: './customer.component.html',
  styleUrl: './customer.component.scss'
})
export class CustomerComponent implements OnInit {
  customerForm!: FormGroup;
  emailSenders: EmailSenderDto[] = [];
  useMailing: boolean = false;
  selectedSender?: EmailSenderDto;

  constructor(
    private customerService: CustomerService,
    private errorService: ErrorService,
    private footerService: FooterService,
    private translocoService: TranslocoService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.customerService.getCustomer().subscribe({
      next: (customerDto: CustomerDto) => {
        if(customerDto.useMailing){
          this.useMailing = true;
          this.emailSenders = customerDto.emailSenders;
          this.selectedSender = this.emailSenders.find(p => p.email === customerDto.senderEmail);
          if (!this.selectedSender) {
            this.emailSenders.unshift({ email: customerDto.senderEmail, senderName: customerDto.senderName ?? "" });
            this.selectedSender = this.emailSenders[0];
          }
        }

        this.customerForm = CustomerFormFactory.createCustomerForm(this.fb, customerDto);

        this.customerForm.valueChanges.subscribe(() => {
          this.footerService.showFooter(() => this.update());
        });
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate("error.title.customer"));
      }
    });
  }

  update(): boolean {
    if (this.customerForm.invalid) {
      this.customerForm.markAllAsTouched();
      return false;
    }

    let customerDto: CustomerDto = this.customerForm.value;

    this.customerService.updateCustomer(customerDto).subscribe({
      error: (errorDto: HttpErrorResponse) => {
        this.errorService.handleError(errorDto, this.translocoService.translate("error.title.edit_customer"));
      }
    });
    return true;
  }

  changeSender(value: any) {
    this.selectedSender = value.value;
    this.customerForm.patchValue({senderEmail: this.selectedSender?.email, senderName: this.selectedSender?.senderName});
  }
}
